/// <reference path="PickAssistant.ts" />

namespace TerminalApp {
    export class ItemShortcutAssistant extends PickAssistant<any> {
        itemInfo: SP.ItemInfo;

        constructor() {
            super(SP.Localize("word_item") + " " + SP.Localize("word_shortcuts"));

            //Item info
            this.addItem(null, true, SP.Localize("sentance_item_info"), SP.Localize("description_item_info"), "fa-solid fa-rectangle-barcode", "black", async () => {
                SP.setAllHash({ "app": "app_item_info", "itemId": this.itemInfo.id });
                this.close();
            });

            //Audit button
            this.addItem(null, true, SP.Localize("sentance_audit_item"), SP.Localize("description_audit_item"), "fa-solid fa-calculator", "black", async () => {
                SP.setAllHash({ "app": "app_audit_stock", "customerId": this.itemInfo.customerId, "itemId": this.itemInfo.id });
                this.close();
            });
        }

        open_with_info(itemInfo: SP.ItemInfo) {
            this.itemInfo = itemInfo;
            super.open(null);

        }

        async open_with_id(id: string) {
            this.itemInfo = await SP.Data.Item.getItemInfo(id);
            super.open(null);
        }
    }

}